import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";
import { AuthRedirectService, AuthService } from "../services";

export const adminAuthCanMatchGuard: CanMatchFn = (_route, segments) => {
    const authService = inject(AuthService);
    const redirectService = inject(AuthRedirectService);

    if (authService.hasValidSession("admin")) {
        return true;
    }

    const returnUrl = "/" + segments.map((segment) => segment.path).join("/");

    return redirectService.createAdminLoginUrlTree(returnUrl || "/");
};
